'use strict';

// Cut-down reimplementation of i18n client-side handler, compatible with i18n-2 sources.

var vsprintf = require("sprintf-js").vsprintf;
var locales = { en: require('locales/en.json') };
var locale = 'en';

function dotNotation(obj, is, value) {
   if (obj.hasOwnProperty(is)) {
      return obj[is];
   }

   if (typeof is === 'string') {
      return dotNotation(obj, is.split('.'), value);
   } else if (is.length === 1 && value !== undefined) {
      return obj[is[0]] = value;
   } else if (is.length === 0) {
      return obj;
   } else {
      if (obj.hasOwnProperty(is[0])) {
         return dotNotation(obj[is[0]], is.slice(1), value);
      } else {
         return obj[is.join('.')] = is.join('.');
      }
   }
}

module.exports = {
   __: function __(singular) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
         args[_key - 1] = arguments[_key];
      }

      var msg = void 0;
      // console.log('i18n 1', arguments)
      if (!locale || !locales[locale] || !locales[locale][singular]) {
         msg = singular;
      } else {
         msg = dotNotation(locales[locale], singular, undefined);
      }

      // console.log('i18n 2', msg)

      if (args && args.length > 0) {
         msg = vsprintf(msg, args);
      }
      // console.log('i18n 3', msg)

      return msg;
   }
};


//////////////////
// WEBPACK FOOTER
// ./common/helpers/i18n.js
// module id = 94
// module chunks = 0